import { Controller } from "stimulus"
import Choices from "choices.js"
import { put } from '@rails/request.js'

export default class extends Controller {

  connect() {
    // console.log('choicesjs controller');
    const choices = new Choices(this.element, {
      removeItems: false,
      removeItemButton: false,
      shouldSort: false,
      classNames: {
        containerOuter: 'choices',
        containerInner: 'choices_custom_inner',
        placeholder: 'choices_custom_placeholder',
      }
    });

    const controller = this

    choices.passedElement.element.addEventListener('change', function (e) {
      e.stopImmediatePropagation()
      e.stopPropagation()
      const { currentValue, fieldType } = e.currentTarget.dataset
      const newValue = e.detail.value
      console.log('current val', currentValue);

      if (confirm(`Are you sure you want to change the ${fieldType}?`)) {
        const body = fieldType === 'booth type' ? { booth_price_option_id: newValue } : { status: newValue }
        controller.dispatch('change', e)
        put(`/crush/vendor_booth_options/${e.currentTarget.dataset.vendorBoothOptionId}?format=json`, {
          body: JSON.stringify(body),
        }).then(response => response.json).then(data => {
          console.log('data', data)
          // window.location.reload()
          if (data.status === 'success') {
            // alert(`${fieldType} updated to ${newValue}`)
          } else {
            choices.setChoiceByValue(currentValue);
            alert(`Error updating ${fieldType}: ${data.errors.join(', ')}`)
          }
        })
      } else {
        // console.log('not confirmed!!!');
        choices.setChoiceByValue(currentValue);
      }
    })

    this.choices = choices
  }
}
